import { render, staticRenderFns } from "./detailClaimsRecord.vue?vue&type=template&id=590b7419&scoped=true&"
import script from "./detailClaimsRecord.vue?vue&type=script&lang=js&"
export * from "./detailClaimsRecord.vue?vue&type=script&lang=js&"
import style0 from "./detailClaimsRecord.vue?vue&type=style&index=0&id=590b7419&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590b7419",
  null
  
)

export default component.exports